module.exports = __webpack_public_path__ + "static/media/childVaccination.11626a5d.svg";